module.exports = __webpack_public_path__ + "img/olej2.93a244a8.jpg";